import { Tabs } from 'antd'
import { FormInstance, TabsProps } from 'antd/lib'
import { useState } from 'react'

import { Placeholder } from 'src/api/requests/models/Placeholder'

import { NotificationContentFormItems } from './NotificationContentFormItems'

type Props = {
  form: FormInstance
  placeholders: Placeholder[]
}

export const LanguageTabs = ({ form, placeholders }: Props) => {
  const [activeKey, setActiveKey] = useState('ro')

  const tabItems: TabsProps['items'] = [
    {
      key: 'ro',
      label: 'RO',
      children: (
        <NotificationContentFormItems
          form={form}
          language="ro"
          placeholders={placeholders}
        />
      )
    },
    {
      key: 'ru',
      label: 'RU',
      children: (
        <NotificationContentFormItems
          form={form}
          language="ru"
          placeholders={placeholders}
        />
      )
    }
  ]

  const onClick = async (key: string) => {
    await form.validateFields([`title_${activeKey}`, `content_${activeKey}`])

    setActiveKey(key)
  }

  return <Tabs onChange={onClick} activeKey={activeKey} items={tabItems} />
}
